module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_long_blonde.4ab6cbae.png";